<template>
  <v-layout>
    <v-dialog v-bind:value="dialog" @click:outside="$emit('updateDialog', false)" max-width="1300">
      <template v-slot:activator="{ on }">
        <v-btn color="primary" class="mb-5" dark v-on="on" @click="$emit('updateDialog', true)">{{ button_name }}</v-btn>
      </template>

      <v-card class="background-voucher" style="background: rgb(221, 225, 230)">
        <v-form v-on:submit.prevent="createItem">
          <v-card-title class="headline mb-4">{{ modal_title }}</v-card-title>

          <v-card-text>
            <!--Datos generales-->
            <v-card elevation="1" class="mb-4">
              <v-card-text>
                <h6 class="text-h6 black--text">Datos generales</h6>
                <p class="text-body-2 mb-0">Ingrese el nombre de la plantilla y los datos del comprobante a precargar</p>

                <v-row class="mt-0">
                  <v-col md="3" class="mt-2">
                    <v-text-field
                      data-vv-as="nombre"
                      label="Nombre*"
                      name="name"
                      v-model="item.name"
                      v-validate="'required|max:100'"
                      autocomplete="off"
                      :disabled="isViewModal()"
                    ></v-text-field>
                    <span class="red--text">{{ errors.first("name") }}</span>
                  </v-col>

                  <v-col md="3" class="mt-2">
                    <v-combobox
                      v-model="item.supplier"
                      item-text="name"
                      item-value="id"
                      :items="suppliers"
                      label="Proveedor"
                      autocomplete="off"
                      clearable
                      :disabled="isViewModal()"
                      @change="loadCbteTipos(true)"
                    ></v-combobox>
                  </v-col>

                  <v-col md="3" class="mt-2">
                    <v-combobox
                      v-model="item.receiver"
                      item-text="name"
                      item-value="id"
                      :items="receivers"
                      label="Receptor"
                      autocomplete="off"
                      clearable
                      :disabled="isViewModal()"
                    ></v-combobox>
                  </v-col>

                  <v-col md="3">
                    <v-combobox
                      v-model="item.cbte_tipo"
                      item-text="Desc"
                      item-value="Id"
                      :items="cbte_tipos"
                      label="Tipo de comprobante"
                      :hint="item.supplier ? '' : 'Seleccione un proveedor'"
                      persistent-hint
                      autocomplete="off"
                      clearable
                      filled
                      :disabled="isViewModal() || cbte_tipos.length == 0"
                    ></v-combobox>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <!--Stock-->
            <v-card elevation="1" class="mb-4" v-if="isProductCompany()">
              <v-card-text>
                <h6 class="text-h6 black--text">Stock</h6>
                <p class="text-body-2">Indique si el comprobante ingresa mercaderia al stock</p>

                <v-row>
                  <v-col md="6">
                    <v-radio-group
                      v-model="item.stock_spent"
                      data-vv-as="stock"
                      name="stock_spent"
                      v-validate="item.items.length > 0 ? 'required' : ''"
                      row
                      :disabled="isViewModal()"
                      @change="changeStock"
                    >
                      <v-radio label="Sin definir" :value="null" color="primary"></v-radio>
                      <v-radio label="Con stock" :value="true" color="primary"></v-radio>
                      <v-radio label="Sin stock" :value="false" color="primary"></v-radio>
                    </v-radio-group>
                    <span class="red--text">{{ errors.first("stock_spent") }}</span>
                  </v-col>
                </v-row>
                <v-row class="mt-0">
                  <v-col md="6" v-if="item.stock_spent === true">
                    <v-combobox
                      v-model="item.warehouse"
                      item-text="name"
                      item-value="id"
                      :items="warehouses"
                      label="Deposito"
                      autocomplete="off"
                      clearable
                      :disabled="isViewModal()"
                    ></v-combobox>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <!--Items-->
            <v-card elevation="1" class="mb-4">
              <v-card-text>
                <h6 class="text-h6 black--text">Ítems</h6>
                <p v-if="!isViewModal()" class="text-body-2">Ingrese los ítems a precargar. Cantidades y precios se completan al generar el gasto</p>

                <v-row>
                  <v-col md="12" v-if="!isViewModal()">
                    <v-btn small color="blue-grey" class="pl-4 text-white" @click="addItem()">
                      <v-icon big color="green"> add </v-icon>
                      <span>Agregar item</span>
                    </v-btn>
                  </v-col>
                  <v-col md="12" class="px-4 pb-4">
                    <v-data-table :headers="header_items" :items="item.items" style="border: solid 1px #1c1c1c" :hide-default-footer="true" :items-per-page="100" no-data-text="Sin ítems">
                      <template v-slot:item="props">
                        <tr>
                          <td v-if="showProduct()" style="min-width: 220px">
                            <v-combobox
                              v-model="props.item.product_presentation"
                              :item-text="presentationLabel"
                              item-value="id"
                              :items="presentations"
                              label="Producto"
                              autocomplete="off"
                              clearable
                              :disabled="isViewModal()"
                              @change="productChange(props.item, $event)"
                            ></v-combobox>
                          </td>
                          <td :style="showProduct() ? 'width: 25%' : 'width: 40%'">
                            <v-text-field v-model="props.item.descripcion" placeholder="Descripción" dense type="text" autocomplete="off" class="mt-3" :disabled="isViewModal()" />
                          </td>
                          <td>
                            <ConceptoCentroPicker
                              :concepto.sync="props.item.concepto"
                              :cost_center.sync="props.item.cost_center"
                              :conceptos="conceptos"
                              :cost_centers="cost_centers"
                              :disabled="isViewModal()"
                              :inTable="true"
                            />
                          </td>
                          <td style="width: 200px; min-width: 200px">
                            <v-combobox v-model="props.item.iva" item-text="Desc" item-value="Id" :items="ivas" label="IVA" autocomplete="off" :disabled="isViewModal()"></v-combobox>
                          </td>
                          <td class="text-center">
                            <v-tooltip bottom v-if="!isViewModal()">
                              <template v-slot:activator="{ on }">
                                <v-icon v-on="on" small color="red" @click="item.items.splice(props.index, 1)"> indeterminate_check_box </v-icon>
                              </template>
                              <span>Remover</span>
                            </v-tooltip>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <!--Tributos-->
            <v-card elevation="1" class="mb-4">
              <v-card-text>
                <h6 class="text-h6 black--text">Tributos</h6>
                <p v-if="!isViewModal()" class="text-body-2">Percepciones especiales que se aplican a perfil fiscal. El importe se completa al generar el gasto</p>
                <v-row>
                  <v-col md="12" v-if="!isViewModal()">
                    <v-btn small color="blue-grey" class="text-white" @click="addTribute()">
                      <v-icon big color="green"> add </v-icon>
                      <span>Agregar item</span>
                    </v-btn>
                  </v-col>
                  <v-col md="12">
                    <v-data-table class="pb-4" :headers="header_tributes" :items="item.tributes" style="border: solid 1px #1c1c1c" :hide-default-footer="true" :items-per-page="100" no-data-text="Sin tributos">
                      <template v-slot:item="props">
                        <tr>
                          <td>
                            <v-combobox
                              v-model="props.item.tribute"
                              data-vv-as="tributo"
                              :name="'tribute_' + props.index"
                              item-text="Desc"
                              item-value="Id"
                              :items="tributos_list"
                              label="Tributo"
                              v-validate="'required|combobox_required'"
                              autocomplete="off"
                              :disabled="isViewModal()"
                            ></v-combobox>
                            <span class="red--text">{{ errors.first("tribute_" + props.index) }}</span>
                          </td>
                          <td v-if="props.item.tribute && props.item.tribute.jurisdiccion">
                            <v-combobox
                              v-model="props.item.jurisdiccion"
                              item-text="name"
                              item-value="id"
                              :items="provincias"
                              label="Provincia"
                              clearable
                              autocomplete="off"
                              :disabled="isViewModal()"
                            ></v-combobox>
                          </td>
                          <td v-else style="min-width: 25%">
                            <v-text-field v-model="props.item.descripcion" placeholder="Descripción" dense type="text" autocomplete="off" class="mt-3" :disabled="isViewModal()" />
                          </td>
                          <td class="text-center">
                            <v-tooltip bottom v-if="!isViewModal()">
                              <template v-slot:activator="{ on }">
                                <v-icon v-on="on" small color="red" @click="item.tributes.splice(props.index, 1)"> indeterminate_check_box </v-icon>
                              </template>
                              <span>Remover</span>
                            </v-tooltip>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <!--Observaciones-->
            <v-card elevation="1" class="mb-4">
              <v-card-text class="pb-0">
                <h6 class="text-h6 black--text">Observaciones</h6>
                <p class="text-body-2">Ingrese una observación</p>
                <v-row class="mt-0">
                  <v-col md="12" class="pb-1 pt-0">
                    <v-textarea
                      rows="3"
                      outlined
                      autocomplete="off"
                      data-vv-as="observación"
                      label="Observacion"
                      name="observation"
                      v-validate="'max:255'"
                      counter="255"
                      v-model="item.observation"
                      :disabled="isViewModal()"
                    />
                    <span class="red--text">{{ errors.first("observation") }}</span>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="$emit('updateDialog', false)">Cancelar</v-btn>
            <v-btn color="green darken-1" text type="submit" v-if="!isViewModal()" :loading="loading">{{ formBtn }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import Constant from "@/constants/sections";
import ModalGenericMixin from "@/mixins/ModalGenericMixin.vue";
import SettingsMixin from "@/mixins/SettingsMixin.vue";
import { generalService } from "@/libs/ws/generalService";
import { emmiterService } from "@/libs/ws/emmiterService";
import { spentService } from "@/libs/ws/spentService";
import { vouchersService } from "@/libs/ws/vouchersService";
import ConceptoCentroPicker from "@/components/ConceptoCentroPicker.vue";

export default {
  mixins: [ModalGenericMixin, SettingsMixin],
  components: { ConceptoCentroPicker },
  props: {
    parent: Object,
    service: Object,
    modal_title: String,
    dialog: Boolean,
    item: Object,
    button_name: String,
    formBtn: String,
  },
  data() {
    return {
      suppliers: [],
      receivers: [],
      warehouses: [],
      cbte_tipos: [],
      presentations: [],
      conceptos: [],
      cost_centers: [],
      provincias: [],
      ivas: spentService.ivas(),
      tributos_list: spentService.tributes(),
    };
  },
  computed: {
    header_items() {
      const headers = [
        { text: "Descripción", value: "descripcion", sortable: false },
        { text: "Centro / Concepto", value: "concepto", sortable: false },
        { text: "IVA", value: "iva", sortable: false, class: "bg-grey" },
        { text: "", value: "", sortable: false, class: "bg-grey" },
      ];
      if (this.showProduct()) headers.unshift({ text: "Producto", value: "product_presentation", sortable: false });
      return headers;
    },
    header_tributes() {
      return [
        { text: "Tributo", value: "tribute", sortable: false },
        { text: "Descripción/Jurisdicción", value: "", sortable: false },
        { text: "", value: "", sortable: false, class: "bg-grey" },
      ];
    },
  },
  watch: {
    item() {
      this.$emit("updateItem", this.item);
    },
    dialog(val) {
      this.errors.clear();
      if (val) {
        this.normalizeItem();
        this.loadCbteTipos(false);
      }
    },
  },
  mounted() {
    this.loadComboData();
  },
  methods: {
    isViewModal() {
      return this.formBtn == "";
    },
    showProduct() {
      return this.isProductCompany() && this.item.stock_spent === true;
    },
    presentationLabel(item) {
      return item.label != undefined ? item.label : item.name;
    },
    // Alinea iva/tributo con las listas del front (IVA "N/A" se persiste como 0)
    normalizeItem() {
      this.item.items.forEach((row) => {
        if (row.iva != null) {
          const iva_id = row.iva.Id === 0 ? null : row.iva.Id;
          row.iva = this.ivas.find((iva) => iva.Id === iva_id) || null;
        }
      });
      this.item.tributes.forEach((row) => {
        if (row.tribute != null) row.tribute = this.tributos_list.find((t) => t.Id === row.tribute.Id) || null;
      });
    },
    addItem() {
      const supplier = this.item.supplier;
      this.item.items.push({
        descripcion: "",
        concepto: supplier ? supplier.concepto : null,
        cost_center: supplier ? supplier.cost_center : null,
        iva: null,
        product_presentation: null,
      });
    },
    addTribute() {
      this.item.tributes.push({ tribute: null, jurisdiccion: null, descripcion: "" });
    },
    changeStock() {
      if (this.item.stock_spent !== true) {
        this.item.warehouse = null;
        this.item.items.forEach((row) => (row.product_presentation = null));
      }
    },
    productChange(row, presentation) {
      if (presentation == null || typeof presentation !== "object") return;
      if (!row.descripcion) row.descripcion = presentation.label;
      if (presentation.concepto != null) row.concepto = presentation.concepto;
      if (presentation.cost_center != null) row.cost_center = presentation.cost_center;
    },
    loadCbteTipos(validateCurrent) {
      if (this.item.supplier == null || typeof this.item.supplier !== "object") {
        this.cbte_tipos = [];
        if (validateCurrent) this.item.cbte_tipo = null;
        return;
      }
      const iva_condition_id = this.item.supplier.iva_condition != null ? this.item.supplier.iva_condition.id : null;
      spentService.cbteTiposInvoice(iva_condition_id, "all").then((response) => {
        if (!response.status) return;
        // Las NC requieren comprobante asociado: no aplican a una plantilla
        this.cbte_tipos = response.result.filter((cbte_tipo) => vouchersService.NoteCreditList().indexOf(cbte_tipo.Id) === -1);
        if (this.item.cbte_tipo != null) {
          this.item.cbte_tipo = this.cbte_tipos.find((cbte_tipo) => cbte_tipo.Id === this.item.cbte_tipo.Id) || null;
        }
      });
    },
    loadComboData() {
      generalService.setSection(Constant.SECTION_SUPPLIERS);
      generalService.filter().then((r) => { this.suppliers = r.result; }).catch(() => {});

      emmiterService.filter({ enabled: true }).then((r) => { this.receivers = r.result; }).catch(() => {});

      generalService.setSection(Constant.SECTION_WAREHOUSES);
      generalService.filter({ enabled: true }).then((r) => { this.warehouses = r.result; }).catch(() => {});

      generalService.setSection(Constant.SECTION_CONCEPTOS);
      generalService.filter().then((r) => { this.conceptos = r.result; }).catch(() => {});

      generalService.setSection(Constant.SECTION_COSTS_CENTERS);
      generalService.filter().then((r) => {
        this.cost_centers = r.result.map((cc) => ({ id: cc.id, name: cc.name }));
      }).catch(() => {});

      generalService.setSection(Constant.SECTION_PROVINCIAS);
      generalService.filter().then((r) => { this.provincias = r.result; }).catch(() => {});

      generalService
        .query({ buyable: true }, Constant.SECTION_PRODUCTS + "/presentations")
        .then((r) => { this.presentations = r.result; })
        .catch(() => {});
    },
    toRef(obj) {
      return obj != null && typeof obj === "object" && obj.id ? { id: obj.id } : null;
    },
    createItem(e) {
      this.$validator.validate().then((valid) => {
        if (!valid) return;
        e.preventDefault();
        this.loading = true;
        const use_stock = this.isProductCompany();
        const stock_spent = use_stock ? this.item.stock_spent : null;
        const data = {
          id: this.item.id,
          name: this.item.name,
          supplier: this.toRef(this.item.supplier),
          receiver: this.toRef(this.item.receiver),
          warehouse: stock_spent === true ? this.toRef(this.item.warehouse) : null,
          cbte_tipo: this.item.cbte_tipo != null && typeof this.item.cbte_tipo === "object" ? this.item.cbte_tipo.Id : null,
          stock_spent: stock_spent,
          observation: this.item.observation,
          items_arr: this.item.items.map((row) => ({
            id: row.id,
            desc: row.descripcion,
            iva_id: row.iva != null && typeof row.iva === "object" ? (row.iva.Id === null ? 0 : row.iva.Id) : null,
            concepto: this.toRef(row.concepto),
            cost_center: this.toRef(row.cost_center),
            product_presentation: stock_spent === true ? this.toRef(row.product_presentation) : null,
          })),
          tributes_arr: this.item.tributes.map((row) => ({
            id: row.id,
            tribute_id: row.tribute.Id,
            desc: row.descripcion,
            jurisdiccion_id: row.tribute.jurisdiccion && row.jurisdiccion != null ? row.jurisdiccion.id : null,
          })),
        };

        const request = this.item.id > 0 ? this.service.update(data) : this.service.create(data);
        request
          .then((r) => {
            if (r.status) {
              this.$toast.success("La " + this.modal_title + (this.item.id > 0 ? " se modificó correctamente." : " se creó correctamente."), "OK");
              this.$emit("loadList");
              this.$emit("updateDialog", false);
            } else {
              this.$toast.error(r.msg, "Error");
            }
          })
          .catch(() => { this.$toast.error("Error al guardar.", "Error"); })
          .finally(() => { this.loading = false; });
      });
    },
  },
};
</script>
